import { Injectable } from '@angular/core';
import { BackendEndpointService } from './backend-endpoint.service';

@Injectable()
export class LanguageStoreService {
  resourceName = 'languages';

  storage = {};

  constructor(private backend: BackendEndpointService) {}

  findAll() {
    return new Promise((resolve, reject) => {
      this.backend
        .get([this.resourceName])
        .then(response => {
          resolve(response);
          // resolve(convertJsonToCollection(response, LanguageModel));
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  findOne(id) {
    return new Promise((resolve, reject) => {
      this.backend
        .get([this.resourceName, id])
        .then(response => {
          // Modelize response data
          // var languageModel = new LanguageModel(response);
          this.storage = response;
          resolve(this.storage);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  createEmpty(obj) {
    // return new LanguageModel(obj);
    return { ...obj };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/language-store.service.ts